$(document).ready(function(){

  $('.bls__slide-content .slide__block-link').on('click', function(e){
    e.preventDefault();
    var target = $(this).attr('href');
    window.location = target;
  })
})

function setUpperMenuWidths(){
  if(!$('.secondary_menu_wrapper .secondary .secondary_menu').hasClass('with_values') || $(window).width() < 1025) return;
  var hm_width = $('#shopify-section-horizontal-menu').width();
  var hm_ul_width = $('.mobile-menu-content ul.horizontal-list').width();
  $('.secondary_menu_wrapper .secondary').css('width', hm_width);
  $('.secondary_menu_wrapper .secondary .secondary_menu').css('width', hm_ul_width);
}

function setUpperMenuLinks(){
  var hiddenMenuItems = $('.main-nav .horizontal-list li.show_secondary_menu');
  if(hiddenMenuItems.length == 0) return;
  var filteredItems = hiddenMenuItems;
  if(shop_locale !== 'it') {
    var filteredItems = hiddenMenuItems.filter((index, item) => !$(item).hasClass('it_only'));
  }
  if(filteredItems.length == 0) return;
  var upperMenu = $('.secondary_menu_wrapper .secondary_menu');
  upperMenu.addClass('with_values');
  $.each(filteredItems, function(i, item){
    var clone = $(item).clone()[0];
    upperMenu.append(clone);
  })
}

$(document).ready(function(){
  setUpperMenuLinks();
  setUpperMenuWidths();
  $(window).on('resize', function(){
    setUpperMenuWidths();
  })
})

function convertiTestoInIntero(testoPrezzo) {
  return parseInt(testoPrezzo.replace(/[^\d]/g, ''), 10);
}



/*

$(document).ready(function(){
  var _tabs = $('.template-product .product.data ul li.data.item a');
  if(_tabs.length == 0) return;
  $.each(_tabs, function(i, _tab){
    var tabText = $(_tab).text();
    var _titleIt = 'Dati tecnici';
    var _titleEn = 'Technical data';
    if(tabText.trim().toLowerCase() === _titleIt.trim().toLowerCase() || tabText.trim().toLowerCase() === _titleEn.trim().toLowerCase()) {
      var targetId = $(_tab).attr('data-block-id');
      var targetElement = $(`.template-product .tab-content #${targetId}`);
      if(targetElement.length == 0) return;
      console.log(targetElement);
    }
  });
})


$(document).ready(function(){
  var selects = $('.product-bought-together-list .variant-select select');
  $.each(selects, function(i, sel){
    $(sel).on('change', function(){
      setTimeout(() => {
        var prices = $('.product-bought-together-list .price__regular .price');
        let somma = 0;
        $.each(prices, function(i, price){
          let single = convertiTestoInIntero($(price).text().trim());
          somma = somma + single;
        })
        var percentualeDellaSomma = (somma * 22) / 100;
        var sommaFormattata = '€' + (somma / 100).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        var iva = '+ IVA: €' + (percentualeDellaSomma / 100).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        console.log(sommaFormattata+' - '+iva);
      }, 700)
    })
  })
});

$(document).ready(function(){
  setTimeout(() => {
    var prices = $('.product-bought-together-list .price__regular .price');
    let somma = 0;
    $.each(prices, function(i, price){
      let single = convertiTestoInIntero($(price).text().trim());
      somma = somma + single;
    })
    var percentualeDellaSomma = (somma * 22) / 100;
    var sommaFormattata = '€' + (somma / 100).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var iva = '+ IVA: €' + (percentualeDellaSomma / 100).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    console.log(sommaFormattata+' - '+iva);
  }, 700)
});
*/

